//GetActiveKOInformationByRegionGroupID

/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2024] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetActiveKOInformationByRegionGroupID(regionGroupId) {
  const response = await $.soap({
    body: {
      GetActiveKOInformationByRegionGroupID: {
        $xmlns: 'http://dla.mil/ems/db/aw_package/ko_information',
        RegionGroupID: regionGroupId
      }
    },
    blueprintArrays: ['GetActiveKOInformationByRegionGroupIDResponse.tuple'],
    blueprint: {
      activeKOs: [
        '$..GetActiveKOInformationByRegionGroupIDResponse.tuple',
        {
          id: '$..KOID',
          koName: '$..Name',
          name: '$..Name',
          pocFirstName: '$..POCFirstName',
          pocLastName: '$..POCLastName',
          pocName: '$..POCName',
          pocEmail: '$..POCEmail',
          pocPhone: '$..POCPhone',
          pocFax: '$..POCFax',
          pgr: '$..PGr',
          pgcCode: '$..PGCCode',
          regionGroupId: '$..RegionGroupID',
          regionGroup: '$..RegionGroup',
          isActive: '$..IsActive',
          address: {
            addressId: '$..AddressID',
            address1: '$..Address1',
            address2: '$..Address2',
            buildingFloorNumber: '$..BuildingFloorNumber',
            roomPoleNumber: '$..RoomPoleNumber',
            city: '$..City',
            zip: '$..Zip',
            regionName: '$..RegionName',
            regionId: '$..RegionID'
          }
        }
      ]
    }
  });
  cleanUpResponse(response);
  return response.activeKOs;
}
